import React from "react";
import { Field, ErrorMessage } from "formik";
import { FaInfoCircle, FaMoneyBillWave } from "react-icons/fa";
import InfoTooltip from "../components/InfoTooltip";
import RadioButton from "../components/RadioButton";

export const Step3 = ({ colors }) => (
  <div
    className="space-y-6 p-6 rounded-lg"
    style={{ backgroundColor: colors.background }}
  >
    <h3
      className="text-2xl font-semibold border-b pb-2"
      style={{ borderColor: colors.border }}
    >
      Cotisation
    </h3>

    <div className="w-full flex items-center justify-between">
      <p className="text-sm" style={{ color: colors.text }}>
        Pour rappel, le montant de la cotisation annuelle s'élève à 15€.
      </p>
      <InfoTooltip
        title="Information"
        text="La cotisation annuelle est fixée par le réglement intérieur de l'association. Elle Doit être effectuée au plus tard 30 jours après l’Assemblée Générale ordinaire clôturant la saison
passée"
      />
    </div>
    <div>
      <span
        className="block text-sm font-medium mb-2"
        style={{ color: colors.text }}
      >
        <FaInfoCircle
          className="inline-block mr-2"
          style={{ color: colors.primary }}
        />
        Statut <span style={{ color: colors.secondary }}>*</span>
      </span>
      <div className="space-y-2">
        {["Adhésion", "Réadhésion"].map((option, index) => (
          <RadioButton
            name="statut"
            value={option}
            label={option}
            key={index}
          />
        ))}
      </div>
      <ErrorMessage
        name="statut"
        component="div"
        className="mt-1 text-sm"
        style={{ color: colors.secondary }}
      />
    </div>

    <div>
      <span
        className="block text-sm font-medium mb-2"
        style={{ color: colors.text }}
      >
        <FaMoneyBillWave
          className="inline-block mr-2"
          style={{ color: colors.primary }}
        />
        Mode de paiement <span style={{ color: colors.secondary }}>*</span>
      </span>
      <div className="space-y-2">
        {["Virement bancaire", "PayPal", "Espèces"].map((option, index) => (
          <RadioButton
            name="modePaiement"
            value={option}
            label={option}
            key={index}
          />
        ))}
      </div>
      <ErrorMessage
        name="modePaiement"
        component="div"
        className="mt-1 text-sm"
        style={{ color: colors.secondary }}
      />
    </div>
  </div>
);
